exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1N1zI2BgoVAX-l img{height:140px;width:280px;border-radius:3px}._1N1zI2BgoVAX-l p{text-align:center;font-size:14px;line-height:20px;color:#5e6c84;padding-bottom:8px}._2_VA3TgQs82Iwl{padding-top:15px;font-size:16px;line-height:20px;text-align:center;color:#000}._2D4A_C1TWeTpJw{margin-bottom:0;border-radius:3px}", ""]);

// exports
exports.locals = {
	"workspacesPreamblePromptInviteIntro": "_1N1zI2BgoVAX-l",
	"workspacesPreamblePromptInviteIntroTitle": "_2_VA3TgQs82Iwl",
	"workspacesPreamblePromptInviteIntroContinueButton": "_2D4A_C1TWeTpJw"
};